/**
 * The public marketing tree (meridiananesthesia.com, served from /website/*)
 * must be auth-inert: no Supabase session checks, no role/capability fetches,
 * no auth listeners, no platform polling. Client components that would
 * otherwise talk to the platform on mount consult this predicate first.
 *
 * Keep in sync with AppShell's public-route entry for '/website'.
 *
 * This checks the ADDRESS BAR only. On meridiananesthesia.com the address is
 * the clean URL ("/about"), so root-layout components use the segment-aware
 * useIsMarketingRoute() (./use-marketing-route.ts) instead.
 */
export function isMarketingPath(pathname: string | null | undefined): boolean {
  return !!pathname && (pathname === '/website' || pathname.startsWith('/website/'))
}
